import { Typography } from '@mui/material'

const OtherStatBox = ({ value, label }) => {
  return (
    <div
      style={{
        color: 'rgba(100, 118, 140, 1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '9px 14px',
        borderRadius: '8px',
      }}
    >
      <Typography
        sx={{
          color: '#3C4FB9',
          fontWeight: '500',
          fontSize: '36px',
          fontFamily: 'Roboto Slab',
        }}
      >
        {value}
      </Typography>
      <Typography sx={{ fontSize: { lg: '14px', md: '12px', sm: '12px', xs: '12px' } }}>{label}</Typography>
    </div>
  )
}

export default OtherStatBox
